<template>
  <v-container grid-list-xs>

    <v-snackbar v-model="snackErreur" color="red">
      {{snackMessage}}
      <v-btn text color="primary" @click.native="snackErreur = false">{{ $tr.dialogCommon.close }}</v-btn>
    </v-snackbar>

    <h1>{{((container != undefined) && (container != "")) ? $tr.container.histoMovementContainer +" "+ container : $tr.container.histoMovement}}</h1>

    <!-- Boutons de commandes générales -->
    <h-group class="my-2">

      <v-text-field v-model="search" append-icon="mdi-magnify" label="Recherche" class="mx-4" style="max-width: 250px" single-line hide-details></v-text-field>

      <v-spacer></v-spacer> 

      <v-text-field name="dateLimite" class="mr-4" style="max-width: 200px" type="date" label="Date limite" v-model="dateLimite"></v-text-field>  

      <v-btn color="lightgrey" class="mr-4" @click="rafraichir()">
        <v-icon left>mdi-refresh</v-icon>
        {{ $tr.dialogCommon.refresh }}</v-btn>

      <v-btn color="lightgrey" class="mr-4" @click="exporter()">
        <v-icon left>mdi-export</v-icon>
        {{ $tr.dialogCommon.export }}</v-btn>

      <v-btn color="success" class="mr-4" @click="retour()">
        <v-icon left>mdi-arrow-left</v-icon>
        {{ $tr.dialogCommon.back }}</v-btn>
    </h-group>

    <v-data-table dense :loading="loading" :headers="headers" :items="historique" item-key="ctCtId" class="elevation-1" :search="search" :items-per-page="1000">
      <template v-slot:item.ctdaDate="{ item }">
        {{ computeDate(item.ctdaDate) }}
      </template>
    </v-data-table>
    
  </v-container>
</template>

<script>
import axios from 'axios';

export default {

  data() {
    return {

      historique: [],
      loading: false,
      snackErreur: false,
      snackMessage: "",
      container: "",

      headers: [
         { text: this.$tr.container.hc1, value: 'ctdaContainer' }, //Container
         { text: this.$tr.container.hc2, value: 'ctdaDate' },  //Date
         { text: this.$tr.container.hc3, value: 'ctdaOperation' }, //Opération
         { text: this.$tr.container.hc4, value: 'duree' }, //Durée présence
         { text: this.$tr.container.hc5, value: 'ctdaTrain' }, //Train
         { text: this.$tr.container.hc6, value: 'ctdaWagon' }, //Wagon
         { text: this.$tr.container.hc7, value: 'ctdaScac' }, //Scac
         { text: this.$tr.container.hc8, value: 'ctdaStatut' }, //Statut
         { text: this.$tr.container.hc9, value: 'ctdaExpedition' }, //Expédition
         { text: this.$tr.container.hc10, value: 'ctdaSeal' }, //Seal
         { text: this.$tr.container.hc11, value: 'ctdaNestleBookingNumber' }, //NW booking number
         { text: this.$tr.container.hc12, value: 'ctdaTerminal' }, //Terminal
      ],

      search: "",

      voirUniquementContainersPresents: true,

      dateLimite: undefined,

    }
  },

  methods: {
    rafraichir() {
      this.loading = true;
      var filter;
      var dateFilter = {"ctdaDate": {"gt": new Date(this.dateLimite)}};

      if ((this.container != undefined) && (this.container != "")) {
        // Filtre sur la date et le numéro de container
        filter =  {
          "where": {"and": [
            dateFilter,
            {"ctdaContainer": this.container}
          ]},
          "order": "ctdaDate DESC"
        }
      }
      else {
        // Filtre sur la date uniquement
        filter =  {"where": dateFilter, "order": "ctdaDate DESC"}
      }
      
      var url = "/api/ctdaContainerDepartArrivees?filter=" + JSON.stringify(filter) + "&access_token=" + this.$user.id;
      axios.get(url)
        .then(function (response) {
          const historique = response.data;
          for (var idx = 0; idx < historique.length; idx++) {
            const histo = historique[idx];
            if (histo.ctdaOperation == "départ") {
              if (idx < historique.length - 1) {
                if (historique[idx + 1].ctdaOperation == "arrivée") {
                  // Calcul de la durée
                  const d1 = new Date(histo.ctdaDate);
                  const d0 = new Date(historique[idx + 1].ctdaDate);
                  const duree = (d1.getTime() - d0.getTime()) / 1000 / 3600 / 24;
                  histo.duree = duree >= 0 ? Math.round(duree).toFixed(0) + " jour" + (Math.round(duree) >=2 ? "s" : "") : "-";
                }
              }
            }

          }
          this.historique = response.data;
          this.loading = false;
        }.bind(this))
        .catch(error => {
          if (error.response.status == 401) {
            // Erreur "accès refusé", redirection vers la page de connexion
            this.$router.push('/login?to=/containers')
          }
          else {
            this.snackMessage = error.message + " : " + error.response.statusText;
            this.snackErreur = true
            this.loading = false;
            this.containersFiltres = [];
            this.containers   = [];
          }
        });
    },

    exporter() {
      this.$exporterCsv(this.historique, "export-historique-containers.csv")
    },

    computeDate(sdate) {
      return sdate != null ? sdate.substr(0,10) : "";
    },

    retour() {
      this.$router.go(-1);
    }
  },

  mounted() {
    this.dateLimite = new Date(Date.now() - 86400 * 1000 * 366).toISOString().substr(0,10)
    this.container = this.$route.params.container;
    this.rafraichir();
  },

  watch: {
    $route(to) {
      if (to.url.startsWith('/histocontainer/')) {
        this.container = this.$route.params.container;
        this.rafraichir
      }
    }
  },

}
</script>

<style>

</style>